import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import * as xml2js from 'xml2js';
import {Observable, of, switchMap} from 'rxjs';
import {Expiration} from "../../interfaces/Expiration";
import {PlayerList} from "../../player/player.list";
import {catchError} from "rxjs/operators";

@Component({
  selector: 'app-custom-rss-player',
  template: `
    <div #component>
      <template #playercontainer></template>
      <ngx-flicking #flk [options]=options>
          <app-flicking-item flicking-panel *ngFor="let page of pages" class="flicking-panel"
                       [setParentPlayer]="this"
                       [setEditMode]="editMode"
                       [setPage]="page">
          </app-flicking-item>
      </ngx-flicking>
    </div>`,
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomRssPlayerComponent extends PlayerList {
  constructor(protected  injector: Injector) {
    super(injector);
  }

  getConfig() {
    let config = this.data.Rss[0].$;
    if (config==null) {
      config = {};
    }
    config.itemInterval = this.data.Rss[0].CustomRss[0].$?.itemInterval;
    config.displayMode = this.data.Rss[0].CustomRss[0].$?.displayMode;
    config.vertical = this.data.Rss[0].CustomRss[0].$?.vertical;
    config.playVideoInFull = this.data.Rss[0].CustomRss[0].$?.playVideoInFull;
    config.volume = this.data.Rss[0].CustomRss[0].$?.volume;
    return config;
  }
  getScene() { return this.data.Rss[0].CustomRss[0].Player[0]; }

  loadProviderData(): Observable<any> {
    if (this.data.Rss[0].rss!=null) {
      return of(this.data.Rss[0].rss[0].channel[0].item);
    }
    this.url = this.data.Rss[0].$.url;
    return of('a').pipe(
      switchMap( a => this.playerService.caching.requestText(this.url, 'customRss', Expiration.Minute, this.playerService.getProxyUrl())),
      switchMap( data => {
        if (data != null) {
          xml2js.parseString(data, (err, result) => {
            this.providerData = result.rss.channel[0].item;
            this.index = 0;
            this.lastRefresh = new Date().getTime();
          })
        }
        return of(this.providerData);
      }),
      catchError( err => of(null) )  // it happens when there is invalid url
    )
  }
}
